module.exports = __webpack_public_path__ + "img/m-plan-2-1.ea7ed149.png";